module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "loginSection"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-5",
    attrs: {
      "id": "loginPanel"
    }
  }, [_c('el-popover', {
    ref: "verifyImg",
    attrs: {
      "placement": "bottom-end",
      "width": "170",
      "trigger": "focus"
    },
    on: {
      "show": _vm.changeImg
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "src": _vm.verifyImgUrl
    }
  })]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username",
      "error": _vm.error.username
    }
  }, [_c('el-input', {
    staticStyle: {
      "outline": "medium"
    },
    attrs: {
      "placeholder": "请输入帐号/姓名/手机号",
      "maxlength": 32
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('img', {
    staticStyle: {
      "width": "18px",
      "height": "18px"
    },
    attrs: {
      "src": require("../../../static/img/login_icon_01.png"),
      "alt": ""
    }
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    ref: "password",
    attrs: {
      "prop": "password",
      "error": _vm.error.password
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "maxlength": 32
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('img', {
    staticStyle: {
      "width": "18px",
      "height": "18px"
    },
    attrs: {
      "src": require("../../../static/img/login_icon_02.png"),
      "alt": ""
    }
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    ref: "verify_code",
    attrs: {
      "prop": "verify_code",
      "error": _vm.error.verify_code
    }
  }, [_c('el-input', {
    directives: [{
      name: "popover",
      rawName: "v-popover:verifyImg",
      arg: "verifyImg"
    }],
    attrs: {
      "placeholder": "请输入验证码",
      "maxlength": 5
    },
    model: {
      value: (_vm.form.verify_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "verify_code", $$v)
      },
      expression: "form.verify_code"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('img', {
    staticStyle: {
      "width": "18px",
      "height": "18px"
    },
    attrs: {
      "src": require("../../../static/img/login_icon_03.png"),
      "alt": ""
    }
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "",
      "active-value": "yes",
      "inactive-text": "",
      "inactive-value": "no"
    },
    model: {
      value: (_vm.form.remember),
      callback: function($$v) {
        _vm.$set(_vm.form, "remember", $$v)
      },
      expression: "form.remember"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row submitArea"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('el-button', {
    staticClass: "btn-block",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.loginSubmit
    }
  }, [_vm._v("登录")])], 1)])], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "logoArea"
    }
  }, [_c('label', {
    staticClass: "loginLogoCss"
  }, [_vm._v("HR融担平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "row loginFooter"
  }, [_c('p', {
    staticClass: "text-center loginfFooterText"
  }, [_vm._v("版权所有：福州索弗企业管理咨询有限公司")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-179959b1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/part/system/login.vue
// module id = 1208
// module chunks = 105